import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { env } from "../env";
import { getLocalStorage } from "../utils/function/localStorage";

export const withdrawApi = createApi({
  reducerPath: "withdrawApi",
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    // mode: "cors",
    prepareHeaders: (headers) => {
      headers.set("X-Auth-Token", getLocalStorage("tp_Aa_uth_access"));
      return headers;
    },
  }),
  tagTypes: ["User", "Task", "Profile", "leaderBoard", "Wallet"], // automatic-data fetching
  endpoints: (builder) => ({
    getMinimumWithdrawAmount: builder.query({
      query: () => "/secure/get-minimum-withdraw-amount",
      providesTags: ["Withdraw"],
    }),
    getWithdrawChargeAmount: builder.query({
      query: () => "/secure/get-withdraw-charge-amount",
      providesTags: ["Withdraw"],
    }),
    withdrawHistory: builder.query({
      query: ({ page, limit }) =>
        `/secure/withdrawals?page=${page}&limit=${limit}`,
      providesTags: ["Withdraw"],
    }),
     getappwithrawtabstatus: builder.query({
      query: () =>
        `/secure/getappwithrawtabstatus`,
      providesTags: ["Withdraw"],


    }),
    withdraw: builder.mutation({
      query: (body) => ({
        url: "/secure/withdraw",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["Withdraw"],
    }),
    getBank: builder.query({
      query: () => "/secure/fetch_payment_details",
      providesTags: ["Bank"],
    }),
    getUPI: builder.query({
      query: () => "/secure/fetch_upi",
      providesTags: ["Bank"],
    }),
    getWallet: builder.query({
      query: () => "/secure/get-wallet",
      providesTags: ["Wallet"],
    }),
    getPremiumUserCharge: builder.query({
      query: () => '/secure/premium-user-charge',
      providesTags: ['PremiumUserCharge'],
    }),
    getPremiumPlusUserCharge: builder.query({
      query: () => '/secure/premium-plus-user-charge',
      providesTags: ['PremiumPlusUserCharge'],
    }),
    uploadWithdrawProof: builder.mutation({
      query: (body) => ({
        url: "/secure/UserWithDrawApiProof",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["Proof"],
    }),

    getUserWithdrawProofHistory: builder.query({
      query: () => "/secure/UserWithDrawApiProofHistory",
      providesTags: ["ProofHistory"],
    }),

    UserWithdrawStatus: builder.query({
      query: () => "/secure/UserWithdrawStatus",
      providesTags: ["ProofHistory"],
    }),

    getspecificuserwithdrawdetail: builder.query({
      query: (id) => `secure/getspecificuserwithdrawdetail?id=${id}`,
      providesTags: ["Withdraw"],
    }),
    getsumofallsuccessfullwithdraw: builder.query({
      query: () => "/secure/getsumofallsuccessfullwithdraw"
    }),
    assignUserToWithdraw: builder.mutation({
      query: (id) => ({
        url: `/secure/User_Assigned/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["Withdraw"],
    }),

    removeAssignedUserFromWithdraw: builder.mutation({
      query: (id) => ({
        url: `/secure/RemoveAssignedUser/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: ["Withdraw"],
    }),

    Submitresponseandproof: builder.mutation({
      query: (formData) => ({
        url: "/secure/submitresponseandproof",
        method: "PATCH",
        body: formData, // 👈 we're not re-creating it here
      }),
      invalidatesTags: ["Proof"],
    }),


    updateWithdrawStatus: builder.mutation({
      query: ({ withdrawid, requestStatus }) => ({
        url: `/secure/User_Update_WithdrawStatus/${withdrawid}`,
        method: "PATCH",
        body: { requestStatus },
      }),
      invalidatesTags: ["Withdraw"],
    }),

    getUserWithdrawHistory: builder.query({
      query: ({ username, id }) =>
        `/secure/getuserwithdrawhistory?username=${username}&id=${id}`,
      providesTags: ["Withdraw"],
    }),

    getAssignedWithdrawTransactions: builder.query({
      query: () => "/secure/AssignedTransaction",
      providesTags: ["Withdraw"],
    }),

    Moderator2UpdateWithdrawStatus: builder.mutation({
      query: ({ withdrawid, requestStatus }) => ({
        url: `/secure/Moderator2_Update_WithdrawStatus/${withdrawid}`,
        method: "PATCH",
        body: { requestStatus },
      }),
      invalidatesTags: ["Withdraw"],
    }),

    getUserModeratorWithdraws: builder.query({
      query: () => '/secure/getUserModeratorWithdraws',
    }),
    getUserModeratorWithdrawsHistory: builder.query({
      query: () => '/secure/moderatorUserReimbursementHistory',
    }),

    moderatorUserReimbursementHistory: builder.query({
      query: (params) => ({
        url: "/secure/moderatorUserReimbursementHistory",
        method: "GET",
        params,
      }),
    }),
    getWithdrawCharge: builder.query({
      query: () => "/secure/get-withdraw-charge",
      providesTags: ["Withdraw"],
    }),
  }),
});

export const {
  useSubmitresponseandproofMutation,
  useGetMinimumWithdrawAmountQuery,
  useGetWithdrawChargeAmountQuery,
  useWithdrawHistoryQuery,
  useWithdrawMutation,
  useGetBankQuery,
  useGetUPIQuery,
  useGetWalletQuery,
  useGetPremiumUserChargeQuery,
  useGetPremiumPlusUserChargeQuery,
  useUploadWithdrawProofMutation,
  useGetUserWithdrawProofHistoryQuery,
  useUserWithdrawStatusQuery,
  useGetspecificuserwithdrawdetailQuery,
  useLazyGetspecificuserwithdrawdetailQuery,
  useAssignUserToWithdrawMutation,
  useRemoveAssignedUserFromWithdrawMutation,
  useUpdateWithdrawStatusMutation,
  useGetUserWithdrawHistoryQuery,
  useGetAssignedWithdrawTransactionsQuery,
  useModerator2UpdateWithdrawStatusMutation,
  useGetsumofallsuccessfullwithdrawQuery,
  useGetUserModeratorWithdrawsQuery,
  useGetUserModeratorWithdrawsHistoryQuery,
  useModeratorUserReimbursementHistoryQuery,
  useGetWithdrawChargeQuery,
  useGetappwithrawtabstatusQuery
} = withdrawApi;